module.exports = __webpack_public_path__ + "media/coffee-preferences/cream_and_sugar_medium-21d357dc.png";